import BaseM from "./recordm.model.entity.js";
import RecordmImporterStatM from "./recordm.importer.model.stat.base.js";
import UriBuilder from "../helpers/module.uribuilder.js";
import {format as formatDateTime} from "../fields/recordm.fields.datetime.js";
import tmpl_ongoing_import_msg from "../templates/recordm-importer-stats-ongoing-import-msg.dot";

import utils from '@cob/ui-genesis/cob.utils.js';

const RecordmImporterSummaryStatM = function(core, statJson) {
    RecordmImporterStatM.apply(this, [core, statJson]);

    const ongoingImportMsg = this.core.translateString('recordm-importer-stats','import-in-progress') || "In Progress";
    this._importInProgressMsg = tmpl_ongoing_import_msg({msg: ongoingImportMsg});
};

RecordmImporterSummaryStatM.prototype = new RecordmImporterStatM();
RecordmImporterSummaryStatM.prototype.constructor = RecordmImporterSummaryStatM;

RecordmImporterSummaryStatM.isSummaryStat = function(statJson){
    return statJson._source.type === "summary";
};

RecordmImporterSummaryStatM.prototype.getSearchableFields = function() {
    const importInProgressMsg = this._importInProgressMsg;

    return [
        BaseM._buildEntityField("import_id", {
            label: this.core.translateString("recordm-importer.stats", "fields.import_id"),
            visibleByDefault: true,
            formatter: function(value, context) {
                var uri = UriBuilder.buildUriForImportDetailsWithSimpleSearch(context.id, "*");
                return value
                       ? '<a href="#/' + uri + '" class="link normal-fontsize">' + value + '</a>'
                       : value;
            }
        }),
        BaseM._buildEntityField("start_date", {
            label: this.core.translateString("recordm-importer.stats", "fields.start_date"),
            visibleByDefault: true,
            type: BaseM.fieldDataType.DATETIME,
            align: "center",
            formatter: function(value, context, def, locale) {
                if(value){
                    return formatDateTime(value, locale);
                }
                return "";
            }
        }),
        BaseM._buildEntityField("end_date", {
            label: this.core.translateString("recordm-importer.stats", "fields.end_date"),
            visibleByDefault: true,
            type: BaseM.fieldDataType.DATETIME,
            align: "center",
            formatter: function(value, context, def, locale) {
                if(value){
                    return formatDateTime(value, locale);
                }

                return importInProgressMsg;
            }
        }),
        BaseM._buildEntityField("duration", {
            label: this.core.translateString("recordm-importer.stats", "fields.duration"),
            visibleByDefault: true,
            align: "center",
            formatter: function(value, context) {
                const endDate = context.end_date;
                const startDate = context.start_date;

                if(value !== undefined){
                    return utils.time.getDurationFromTimeStamp(value);
                } else if(endDate !== undefined && startDate !== undefined){
                    return utils.time.getDurationFromTimeStamp(endDate - startDate);
                }

                return "";
            }
        }),
        BaseM._buildEntityField("user", {
            label: this.core.translateString("recordm-importer.stats", "fields.user"),
            visibleByDefault: true
        }),
        BaseM._buildEntityField("total", {
            label: this.core.translateString("recordm-importer.stats", "fields.total"),
            visibleByDefault: true,
            type: BaseM.fieldDataType.NUMBER,
            align: "right"
        }),
        BaseM._buildEntityField("num_successes", {
            label: this.core.translateString("recordm-importer.stats", "fields.num_successes"),
            visibleByDefault: true,
            type: BaseM.fieldDataType.NUMBER,
            align: "right"
        }),
        BaseM._buildEntityField("num_errors", {
            label: this.core.translateString("recordm-importer.stats", "fields.num_errors"),
            visibleByDefault: true,
            type: BaseM.fieldDataType.NUMBER,
            align: "right"
        }),
        BaseM._buildEntityField("num_discarded", {
            label: this.core.translateString("recordm-importer.stats", "fields.num_discarded"),
            visibleByDefault: true,
            type: BaseM.fieldDataType.NUMBER,
            align: "right"
        }),
        BaseM._buildEntityField("importer", {
            label: this.core.translateString("recordm-importer.stats", "fields.importer")
        })
    ];
};

RecordmImporterSummaryStatM.prototype.getTotal = function(){
    return this.stat.total;
};

RecordmImporterSummaryStatM.prototype.getNumSuccesses = function(){
    return this.stat.num_successes;
};

RecordmImporterSummaryStatM.prototype.getNumErrors = function(){
    return this.stat.num_errors;
};

RecordmImporterSummaryStatM.prototype.getNumDiscarded = function(){
    return this.stat.num_discarded;
};

RecordmImporterSummaryStatM.prototype.getDuration = function(){
    if(this.stat.duration !== undefined){
        return utils.time.getDurationFromTimeStamp(this.stat.duration);
    } else if(this.stat.end_date !== undefined && this.stat.start_date !== undefined){
        return utils.time.getDurationFromTimeStamp(this.stat.end_date - this.stat.start_date);
    }

    return "";
};

RecordmImporterSummaryStatM.prototype.getUser = function(){
    return this.stat.user || "";
};

// Needed to show the message on the stat details template (see templates/recordm-importer-stats-details.dot)
RecordmImporterSummaryStatM.prototype.getImportInProgressMsg = function(){
    return this._importInProgressMsg;
};

RecordmImporterSummaryStatM.prototype.refresh = function(){
    const id = this.getId();

    this.get(id);
};


export default RecordmImporterSummaryStatM;
